'use client'

import { Builder, withChildren } from '@builder.io/react'
import type { Input } from '@builder.io/sdk'

import { StickyFooter } from './StickyFooter'

const defaultChildren = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    id: 'builder-4d4ba5a36c9d455687c177dc11634037',
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        id: 'builder-7831daa8249f4909a356736147899555',
        component: {
          name: 'Text',
          options: {
            text: '<p>Extreme results in half the time</p>',
            style: 'Heading 3',
          },
        },
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flexShrink: '0',
            boxSizing: 'border-box',
            height: 'auto',
            textAlign: 'center',
            lineHeight: '0px',
            justifyContent: 'center',
          },
          medium: {
            display: 'flex',
          },
          small: {
            display: 'none',
          },
        },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        id: 'builder-eb2cbffe8e514418b9b50b09e247e26f',
        children: [
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            id: 'builder-91e069c4eefa420194fad46b0d6a81f7',
            component: {
              name: 'ActionLink',
              options: {
                actionName: 'link',
              },
            },
            children: [
              {
                '@type': '@builder.io/sdk:Element',
                '@version': 2,
                actions: {
                  click:
                    '((inputName, block, context, builder, event, state)=>{\n    var _block_component_options, _block_component, _context_builderContent, _block_component_options1, _block_component1;\n    if (builder.preview) {\n        // eslint-disable-next-line no-console\n        console.log("button fuctions will not execute on builder preview");\n        return;\n    // return\n    }\n    const actionName = block === null || block === void 0 ? void 0 : (_block_component = block.component) === null || _block_component === void 0 ? void 0 : (_block_component_options = _block_component.options) === null || _block_component_options === void 0 ? void 0 : _block_component_options[inputName];\n    const builderContentData = context === null || context === void 0 ? void 0 : (_context_builderContent = context.builderContent) === null || _context_builderContent === void 0 ? void 0 : _context_builderContent.data;\n    const builderArgs = block === null || block === void 0 ? void 0 : (_block_component1 = block.component) === null || _block_component1 === void 0 ? void 0 : (_block_component_options1 = _block_component1.options) === null || _block_component_options1 === void 0 ? void 0 : _block_component_options1[actionName];\n    if (context.builderActions[actionName]) {\n        if (event.target) {\n            context.builderActions[actionName](event, state);\n            return;\n        }\n        context.builderActions[actionName](builderArgs, builderContentData);\n    }\n})(\'actionName\', block, context, builder)',
                },
                id: 'builder-992804bb78b54745bf379cf644e4cc41',
                component: {
                  name: 'Button',
                  options: {
                    disabled: false,
                    variant: 'primary',
                    actionName: 'none',
                    size: 'medium',
                  },
                },
                children: [
                  {
                    '@type': '@builder.io/sdk:Element',
                    '@version': 2,
                    id: 'builder-2e968d4a71494a4aa38e0d656b496e66',
                    component: {
                      name: 'Text',
                      options: {
                        text: '<p>Start for Free</p><p>with BODi</p>',
                      },
                    },
                    responsiveStyles: {
                      large: {
                        lineHeight: '16px',
                      },
                    },
                  },
                ],
                responsiveStyles: {
                  large: {
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    flexShrink: '0',
                    boxSizing: 'border-box',
                    minHeight: '52px',
                  },
                  small: {
                    minHeight: '52px',
                    width: '100%',
                  },
                },
              },
            ],
            responsiveStyles: {
              large: {
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                flexShrink: '0',
                boxSizing: 'border-box',
              },
              small: {
                width: '100%',
              },
            },
          },
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            id: 'builder-3ee863eddc2f4c68bf3220a28d505d49',
            meta: {
              previousId: 'builder-91e069c4eefa420194fad46b0d6a81f7',
            },
            component: {
              name: 'ActionLink',
              options: {
                actionName: 'link',
              },
            },
            children: [
              {
                '@type': '@builder.io/sdk:Element',
                '@version': 2,
                actions: {
                  click:
                    '((inputName, block, context, builder, event, state)=>{\n    var _block_component_options, _block_component, _context_builderContent, _block_component_options1, _block_component1;\n    if (builder.preview) {\n        // eslint-disable-next-line no-console\n        console.log("button fuctions will not execute on builder preview");\n        return;\n    // return\n    }\n    const actionName = block === null || block === void 0 ? void 0 : (_block_component = block.component) === null || _block_component === void 0 ? void 0 : (_block_component_options = _block_component.options) === null || _block_component_options === void 0 ? void 0 : _block_component_options[inputName];\n    const builderContentData = context === null || context === void 0 ? void 0 : (_context_builderContent = context.builderContent) === null || _context_builderContent === void 0 ? void 0 : _context_builderContent.data;\n    const builderArgs = block === null || block === void 0 ? void 0 : (_block_component1 = block.component) === null || _block_component1 === void 0 ? void 0 : (_block_component_options1 = _block_component1.options) === null || _block_component_options1 === void 0 ? void 0 : _block_component_options1[actionName];\n    if (context.builderActions[actionName]) {\n        if (event.target) {\n            context.builderActions[actionName](event, state);\n            return;\n        }\n        context.builderActions[actionName](builderArgs, builderContentData);\n    }\n})(\'actionName\', block, context, builder)',
                },
                id: 'builder-f09ea6a7610d4a80accb2b1673ff0b7d',
                meta: {
                  previousId: 'builder-992804bb78b54745bf379cf644e4cc41',
                },
                component: {
                  name: 'Button',
                  options: {
                    disabled: false,
                    variant: 'primary',
                    actionName: 'none',
                    size: 'medium',
                  },
                },
                children: [
                  {
                    '@type': '@builder.io/sdk:Element',
                    '@version': 2,
                    id: 'builder-56725cce50c54d9ea5488a0964d5d80b',
                    meta: {
                      previousId: 'builder-2e968d4a71494a4aa38e0d656b496e66',
                    },
                    component: {
                      name: 'Text',
                      options: {
                        text: '<p>Buy It</p><p>for $59.95</p>',
                      },
                    },
                    responsiveStyles: {
                      large: {
                        lineHeight: '16px',
                      },
                    },
                  },
                ],
                responsiveStyles: {
                  large: {
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    flexShrink: '0',
                    boxSizing: 'border-box',
                    minHeight: '52px',
                  },
                  small: {
                    minHeight: '52px',
                    width: '100%',
                  },
                },
              },
            ],
            responsiveStyles: {
              large: {
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                flexShrink: '0',
                boxSizing: 'border-box',
              },
              small: {
                width: '100%',
              },
            },
          },
        ],
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'row',
            position: 'relative',
            flexShrink: '0',
            boxSizing: 'border-box',
            height: 'auto',
            paddingBottom: '0px',
            gap: '8px',
          },
          small: {
            width: '100%',
            justifyContent: 'center',
          },
        },
      },
    ],
    responsiveStyles: {
      large: {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        flexShrink: '0',
        boxSizing: 'border-box',
        height: 'auto',
        justifyContent: 'flex-end',
        gap: '24px',
      },
    },
  },
] as any

export const stickyFooterBuilderConfig: Input[] = [
  {
    name: 'previewMode',
    friendlyName: 'Preview mode',
    helperText: 'Always show the footer, regardless of scroll position',
    type: 'boolean',
  },
  {
    name: 'scrollThresholdDesktop',
    friendlyName: 'Scroll threshold (Desktop, px)',
    helperText: 'How far the user must scroll, in pixels, before the footer appears',
    type: 'number',
    defaultValue: 20,
  },
  {
    name: 'scrollThresholdMobile',
    friendlyName: 'Scroll threshold (Mobile, px)',
    helperText: 'How far the user must scroll, in pixels, before the footer appears on mobile',
    type: 'number',
    defaultValue: 20,
  },
  {
    name: 'useTargetElement',
    friendlyName: 'Use Target Element',
    helperText: 'Use Target Element to trigger Sticky Footer',
    type: 'boolean',
    defaultValue: false,
  },
  {
    name: 'targetElement',
    friendlyName: 'Query Selector for Target Element',
    helperText:
      'This is the Query Select to select a Target Element. Ex: [data-testid=addToCartBtn]',
    type: 'string',
    defaultValue: '',
    showIf: 'options.get("useTargetElement") === true',
  },
]

Builder.registerComponent(withChildren(StickyFooter), {
  name: 'StickyFooter',
  defaultChildren,
  inputs: stickyFooterBuilderConfig,
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/layout-bottombar.svg',
})
